import { useEffect, useMemo } from "react"
import { motion } from "motion/react"

import { AuthLayout } from "@/components/auth-layout"
import { AuthCard, LogoMark } from "@/components/auth-card"

export function VerifyPage() {
  const token = useMemo(
    () => new URLSearchParams(window.location.search).get("token"),
    [],
  )

  useEffect(() => {
    if (!token) return
    window.location.replace(
      `/api/v1/saas/auth/verify?token=${encodeURIComponent(token)}`,
    )
  }, [token])

  return (
    <AuthLayout>
      <LogoMark />
      <AuthCard>
        {!token ? (
          <div className="flex flex-col items-center gap-5 py-6 text-center">
            <h1 className="text-lg font-semibold tracking-tight text-foreground">
              This link is no longer valid
            </h1>
            <p className="text-sm leading-relaxed text-muted-foreground">
              Sign-in links can only be used once and expire after a few
              minutes. Request a fresh one to continue.
            </p>
            <a
              href="/login"
              className="text-sm font-medium text-rose-500 transition-colors hover:text-rose-400"
            >
              Back to sign in
            </a>
          </div>
        ) : (
          <div className="flex flex-col items-center gap-6 py-8 text-center">
            <Spinner />
            <div className="space-y-1.5">
              <h1 className="text-lg font-semibold tracking-tight text-foreground">
                Signing you in
              </h1>
              <p className="text-sm leading-relaxed text-muted-foreground">
                Hang tight, this only takes a moment.
              </p>
            </div>
          </div>
        )}
      </AuthCard>
    </AuthLayout>
  )
}

function Spinner() {
  return (
    <motion.div
      className="size-10 rounded-full border-2 border-rose-500/15 border-t-rose-500"
      animate={{ rotate: 360 }}
      transition={{ duration: 0.8, ease: "linear", repeat: Infinity }}
      aria-hidden
    />
  )
}
